import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {  RetailerGuardService } from './retailer-guard.service';
import { HomeComponent } from './home/home.component';
import { LocationComponent } from './location/location.component';
import { RetailersListComponent } from './retailers-list/retailers-list.component';
import { LoginComponent } from './login/login.component';
import { LoggedOutGuardService} from './logged-out-guard.service';
import { OfferComponent } from './offer/offer.component';
import { OffersListComponent } from './offers-list/offers-list.component';
import { RetailerComponent } from './retailer/retailer.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { LoggedInOnlyGuardService } from './logged-in-only-guard.service';
import { ClientGuardService } from './client-guard.service';
import { ApprovalNeededComponent } from './approval-needed/approval-needed.component';
import { ClientOnlyGuardService } from './client-only-guard.service';
import { AdminAccountsComponent } from './admin-accounts/admin-accounts.component';
import { EditAccountComponent } from './edit-account/edit-account.component';


const routes: Routes = [
  { path: '', component: WelcomeComponent},
  { path: 'login', component: LoginComponent, canActivate: [ LoggedOutGuardService ]},
  { path: 'dashboard', component: HomeComponent, canActivate: [ RetailerGuardService ] },
  { path: 'signup', component: SignUpComponent, canActivate: [ LoggedInOnlyGuardService ]},
  { path: 'approval', component: ApprovalNeededComponent, canActivate: [ ClientOnlyGuardService ]},
  { path: 'accounts/:userId', component: EditAccountComponent, canActivate: [ ClientGuardService ]},
  { path: 'ga/accounts', component: AdminAccountsComponent, canActivate: [ ClientGuardService ]},
  { path: 'retailers', component: RetailersListComponent, canActivate: [ RetailerGuardService ]},
  { path: 'retailers/:retailerId', component: RetailerComponent, canActivate: [ RetailerGuardService ]},
  { path: 'retailers/:retailerId/offers', component: OffersListComponent, canActivate: [ RetailerGuardService ]},
  { path: 'retailers/:retailerId/offers/:offerId', component: OfferComponent, canActivate: [ RetailerGuardService ]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
